import AppHeader from "../../layout/AppHeader";
import Reason from '../../xpost/views/umov/reason/Reason.vue';
import ReasonAdd from '../../xpost/views/umov/reason/ReasonAdd.vue';

const ReasonRoutes = [
  {
    path: "/cadastro/motivo",
    name: "reason",
    components: {
      header: AppHeader,
      default: Reason,
    }
  },
  {
    path: "/cadastro/motivo/adicionar",
    name: "reason.add",
    components: {
      header: AppHeader,
      default: ReasonAdd,
    }
  },
  {
    path: "/cadastro/motivo/editar/:id",
    name: "reason.edit",
    components: {
      header: AppHeader,
      default: ReasonAdd,
    }
  },
]

export default ReasonRoutes;